import {
  Icon,
  ICONS,
  Separator,
  RadioInput,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { RadioChangeEvent } from 'antd';
import { FC, useState } from 'react';
import camelCase from 'lodash/camelCase';
import { useTranslation } from 'react-i18next';

import { IRightsListProps } from './gantt-rights-list-select.interfaces';

import { MainContainer, TitleContainer, IconsContainer } from './gantt-rights-list-select.styles';
import { GanttAccessRightsEnum } from '@thinknet-gmbh/platform-common';

const GanttRightsListSelect: FC<IRightsListProps> = ({
  selectedRight,
  ganttName,
  onRightChange,
  isViewSeparator,
  onGanttRightRemove,
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const [isDone, setIsDone] = useState(true);
  const [right, setRight] = useState(selectedRight);

  const onChangeRule = (event: RadioChangeEvent) => {
    setRight(event.target.value);
    onRightChange(event.target.value);
  };

  return (
    <MainContainer>
      <TitleContainer>
        <Typography weight="bold">{ganttName}</Typography>
        {isDone && (
          <IconsContainer>
            <Icon
              icon={ICONS.pencil}
              color={PLATFORM_THEME_COLORS.primary.blue}
              size={16}
              onClick={() => setIsDone(false)}
            />
            <Icon
              icon={ICONS.trash}
              color={PLATFORM_THEME_COLORS.tone.red}
              size={16}
              className="icon"
              onClick={onGanttRightRemove}
            />
          </IconsContainer>
        )}
      </TitleContainer>
      {isDone ? (
        <Typography
          size={TYPOGRAPHY_SIZE.xSmall}
          fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}
        >
          {right && t(`settings:permissionGroupSettings.ganttRights.${camelCase(right)}`)}
        </Typography>
      ) : (
        <Typography
          size={TYPOGRAPHY_SIZE.xSmall}
          fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}
        >
          {t('settings:permissionGroupSettings.labels.selectRights')}
        </Typography>
      )}
      {!isDone && (
        <RadioInput.Group onChange={onChangeRule} value={right}>
          {Object.values(GanttAccessRightsEnum).map(accessRight => (
            <RadioInput key={accessRight} value={accessRight} onClick={() => setIsDone(true)}>
              {t(`settings:permissionGroupSettings.ganttRights.${camelCase(accessRight)}`)}
            </RadioInput>
          ))}
        </RadioInput.Group>
      )}
      {isViewSeparator && <Separator />}
    </MainContainer>
  );
};

export default GanttRightsListSelect;
